import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import Car from "@qivia/ui/src/designSystem/assets/Car.png";
import styled from "styled-components";
import { ElectricVehicleApi } from "../../electricVehiclesAPI";

export const SidePanelHeader = (props: {
  electricVehicle: ElectricVehicleApi;
}) => {
  return (
    <StyledPanelContainer>
      <StyledContent>{props.electricVehicle.registrationNumber}</StyledContent>
      <StyledImg src={Car} alt="Car" />
    </StyledPanelContainer>
  );
};

const StyledPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledContent = styled.div`
  ${typographies["Header/H4"]};
`;

const StyledImg = styled.img`
  filter: grayscale(100%);
  width: 15rem;
  height: 6.5rem;
  object-fit: contain;
`;
